import { render, staticRenderFns } from "./MapRegistrationDialog.vue?vue&type=template&id=5b4cabba&scoped=true"
import script from "./MapRegistrationDialog.vue?vue&type=script&lang=js"
export * from "./MapRegistrationDialog.vue?vue&type=script&lang=js"
import style0 from "./MapRegistrationDialog.vue?vue&type=style&index=0&id=5b4cabba&prod&lang=scss&scoped=true"
import style1 from "./MapRegistrationDialog.vue?vue&type=style&index=1&id=5b4cabba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4cabba",
  null
  
)

export default component.exports